import React, { useContext } from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { MuxSpecificationDashboardContext } from "./context/MuxSpecificationDashboardContext";

export const MuxSpecificationDashboardHeader: React.FC = () => {
    const { isLoading, muxSpecificationDashboardItem } = useContext(MuxSpecificationDashboardContext);

    const resolveMuxSpecificationName = (pathPart: string) => {
        if (pathPart === ":muxSpecificationId") {
            return muxSpecificationDashboardItem.name;
        }

        return undefined;
    };

    return (
        <PageHeader>
            <HeaderBreadcrumb
                key={muxSpecificationDashboardItem.id}
                routes={adminRoutes}
                isLoading={isLoading}
                resolveCustomPathText={resolveMuxSpecificationName}
            />
        </PageHeader>
    );
};
